import { TypographySM } from "@/components/typography/SM";
import { Boxes, Shovel } from "lucide-react";
import { LinkReference } from "./LinkReference";
import { OnboardingStep } from "./OnboardingStep";

interface Props {
  isCompleted: boolean;
}

export function CreateAppStep({ isCompleted }: Props) {
  return (
    <OnboardingStep
      title="Create your first app"
      icon={<Shovel size={18} />}
      isCompleted={isCompleted}
    >
      <TypographySM className="mb-2 leading-6">
        Time to get familiar with the core of Numerous: creating your first app.
      </TypographySM>

      <TypographySM className="leading-6">
        By deploying an app from the{" "}
        <LinkReference icon={Boxes}>App Gallery</LinkReference> page, you can
        get started with one our curated templates that show off some of the
        things that Numerous can do. Or, you can jump right into it by deploying
        an app with your own code.
      </TypographySM>
    </OnboardingStep>
  );
}
